import {forwardRef, useState, useImperativeHandle} from "react";
import {Sheet} from 'react-modal-sheet';
import type {UnnormalizedProps as UnnormalizedStyleProps} from '@yosmanyga/core-style'
import {SpacialFn, styled, VisualFn} from "@yosmanyga/web-style";
import {BottomSheetProps} from '@yosmanyga/primitive-ui-spec'

const BottomSheet = forwardRef(({
    percentage,
    children
}: BottomSheetProps & UnnormalizedStyleProps, ref) => {
    const [open, setOpen] = useState(false);

    useImperativeHandle(ref, () => ({
        close: () => {
            setOpen(false);
        },
        expand: () => {
            setOpen(true);
        }
    }));

    const normalizedPercentage = parseInt(
        percentage.replace('%', '')
    ) / 100;

    return <Sheet
        isOpen={open}
        snapPoints={[normalizedPercentage]}
        onClose={() => {}}
    >
        <Sheet.Container>
            <Sheet.Header />
            <Sheet.Content>
                {children}
            </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop
            onTap={() => {
                console.log('backdrop')
            }}
        />
    </Sheet>
});

const StyledBottomSheet = styled(BottomSheet)`
    ${({padding}) => SpacialFn.compilePadding(SpacialFn.normalizePadding(padding))}
    ${({background}) => VisualFn.compileBackground(VisualFn.normalizeBackground(background))}
`

export default StyledBottomSheet
